export default __webpack_public_path__ + "static/media/PT.a62e4e8f.svg";